import { render, staticRenderFns } from "./CadastrarLocalUnidade.vue?vue&type=template&id=532919ed&scoped=true"
import script from "./CadastrarLocalUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarLocalUnidade.vue?vue&type=script&lang=js"
import style0 from "./CadastrarLocalUnidade.vue?vue&type=style&index=0&id=532919ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532919ed",
  null
  
)

export default component.exports